// @flow
import React from 'react';
import { token } from '@atlaskit/tokens';
import SuccessIcon from '@atlaskit/icon/core/status-success';
import ButtonLink from 'components/common/ButtonLink';
import styled from 'styled-components';
import { Section } from 'modules/checkout/review/details/Commons';
import PaypalLogoUrl from 'components/common/img/logo-paypal.svg';
import { Dimensions, Font } from 'components/visuals';
import * as payment from 'modules/checkout/payment';

const padding = `${Dimensions.units(2)}px`;
const Wrapper = styled(Section)`
  border: 1px solid ${token('color.border.disabled', '#8590A2')};
  width: ${Dimensions.units(50)}px;
  border-radius: 5px;
  padding: ${padding};
  background: url(${PaypalLogoUrl}) no-repeat right ${padding} top ${padding};
  background-size: 130px;
`;

export const Header = styled.h4`
  font-family: ${Font.displayFamily};
  font-weight: 500;
  color: ${token('color.text', '#172B4D')};
  margin-bottom: ${Dimensions.units(1)}px;
`;

// Atlaskit's link button is misaligned by default. Realigning it.
const RealignedButtonLink = styled(ButtonLink)`
  margin-left: -12px;
  margin-top: ${Dimensions.units(2)}px;
`;

type Props = {
  onRemovePayment: () => void,
};
const PaymentPaypalDetails = (props: Props) => {
  const paypal = payment.api.storage.paypalDetails.load();
  return (
    paypal && (
      <Wrapper>
        <Header>
          Paypal account{' '}
          <SuccessIcon size="medium" color={token('color.icon.success', '#00875A')} />
        </Header>
        <div>{paypal.details.email}</div>
        <RealignedButtonLink
          onClick={(e) => {
            e.preventDefault();
            props.onRemovePayment();
          }}
        >
          Remove this account
        </RealignedButtonLink>
      </Wrapper>
    )
  );
};

export default PaymentPaypalDetails;
